import React from 'react'
import PageIntro from '../../components/PageIntro/PageIntro'
import IncompleteProfileTable from '../../components/Table/IncompleteProfileTable'

const IncompleteProfile = () => {
  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro
        title={'Incomplete Profile'}
        description={'Talents who have not finished onboarding.'}
      />
      <IncompleteProfileTable />
    </div>
  )
}

export default IncompleteProfile
